/**
 * Live screens (#1464) — the polling half of "the Grid has to be current".
 *
 * A screen that other people change out from under you (the dispatch board,
 * the shared inbox) re-reads itself on a short interval while its tab is
 * visible, and again the moment the tab regains focus. Spread these on a
 * `useQuery` instead of hand-typing `refetchInterval` so every live surface
 * shares one vocabulary and one set of numbers.
 *
 * Why polling and not push: the SSE pipe (`use-sse.ts`) exists, but nothing on
 * the job / dispatch / mail writes broadcasts on it yet, and the worker (where
 * the auto-scheduler and the mail sync run) can't reach the web process's SSE
 * clients without a bridge. That is step 2 (#1465). Until then this bounds the
 * lag instead of leaving it open-ended.
 *
 * React Query pauses `refetchInterval` while the document is hidden
 * (`refetchIntervalInBackground` defaults to false), so a Grid left open
 * overnight costs nothing. The app-wide `refetchOnWindowFocus: false` in
 * `main.tsx` stays as the default for everything else — only screens that opt
 * in here refresh on focus.
 */

/** The board: another dispatcher's drop must show within one glance. */
export const LIVE_FAST_MS = 15_000;
/** A shared inbox lane: new mail should appear before anyone reaches for F5. */
export const LIVE_MS = 30_000;
/** Supporting lists (folders, snoozed, week load) that change rarely. */
export const LIVE_SLOW_MS = 60_000;

export function live(intervalMs: number): { refetchInterval: number; refetchOnWindowFocus: true } {
    return { refetchInterval: intervalMs, refetchOnWindowFocus: true };
}
